<template>
  <div>
    <div>
      <Form :model="searchData" inline>
        <FormItem prop="gas_name">
          <Input type="text" v-model="searchData.gas_name" placeholder="站点名称" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="station_id">
          <Input type="text" v-model="searchData.station_id" placeholder="站点id" class="lx-search-item"></Input>
        </FormItem>
        <FormItem label="省市区：" prop="province" style="width:450px">
          <Select v-model="searchData.province_name" style="width: 25%" placeholder="省" @on-change="changeProvince">
            <Option value="">请选择</Option>
            <Option v-for="(item,key) in provinces" :value="item" :key="key">{{item}}</Option>
          </Select>
          <Select v-model="searchData.city_name" style="width: 25%" placeholder="市" @on-change="changeCity">
            <Option value="">请选择</Option>
            <Option v-for="(item,key) in citys" :value="item" :key="key">{{item}}</Option>
          </Select>
          <Select v-model="searchData.county_name" style="width: 25%" placeholder="区">
            <Option value="">请选择</Option>
            <Option v-for="(item,key) in countys" :value="item" :key="key">{{item}}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="doSearch">搜索</Button>
        </FormItem>
        <FormItem style="margin-left:20px">
          <Checkbox
            :indeterminate="indeterminate"
            :value="checkAll"
            @click.prevent.native="checkAllCompanyStation">全选</Checkbox>
          <Button type="primary" @click="doSubmit">提交</Button>
        </FormItem>
      </Form>
    </div>

    <div ref="container" class="wrapper">
      <CheckboxGroup v-model="checked" @on-change="editCompanyStationInfoChange" class="custom-checkbox">
        <RecycleScroller
          style="height: 700px"
          :items="stations"
          :item-size="36"
          :min-item-size="36"
          key-field="station_id"
          class="scroller"
          :item-key="(item) => item.station_id"
          ref="scroller"
        >
          <template #default="{ item }">
            <div class="row">
              <Checkbox :label="item.station_id" :key="`${item.station_id}-${checked.includes(item.station_id)}`">
                <Tag color="warning">{{item.platform}}</Tag>
                <Tag color="primary">{{item.price2}}</Tag>
                {{item.station_id}}
                {{item.gas_name}}
                <Tag v-if="item.is_use_platform == 1" color="success">不推平台</Tag>
              </Checkbox>
            </div>
          </template>
        </RecycleScroller>
      </CheckboxGroup>
    </div>
  </div>
</template>

<script>
  import { RecycleScroller } from "vue-virtual-scroller"
  import "vue-virtual-scroller/dist/vue-virtual-scroller.css"
  export default {
    name: "companyStationManage",
    components: { RecycleScroller },
    props:{
      companyId:{
        type:Number,
        default: 0
      },
    },
    data(){
      return {
        searchData:{
          is_search:1,
          gas_name:'',
          platform:'',
          province_name:'',
          city_name:'',
          county_name:'',
          station_id:'',
        },
        checkAll:false,
        indeterminate: true,
        checked:[],
        originalChecked: [],
        stations:[],
        allStationID:[],
        province_county_data:[],
        provinces:[],
        citys:[],
        countys:[],
      }
    },
    methods:{
      async getInfo(){
        if (this.companyId>0){
          let res = await this.$commonFun.postProxy('admin/company/getCompanyStationManageInfo',{company_id:this.companyId,is_search:0});
          this.checked = res.data.checked || [];
          this.originalChecked = [...this.checked];
          this.allStationID = res.data.all_station_ids || [];
          this.stations = res.data.stations || [];
        }

        this.$commonFun.postProxy('admin/tuanyou/getProvince',{}).then((res)=>{
          this.province_county_data = res.data.province_county_data;
          this.provinces = res.data.province_data
        })
      },
      changeProvince(province){
        this.citys = []
        this.province_county_data.forEach((item)=>{
          if (item.value === province){
            item.children.forEach(val=>{
              this.citys.push(val.value)
            })
          }
        })
      },
      changeCity(city){
        this.countys=[]
        let province = this.searchData.province_name
        this.province_county_data.forEach((item)=>{
          if (item.value === province){
            item.children.forEach((val)=>{
              if (val.value === city){
                val.children.forEach(val=>{
                  this.countys.push(val.value)
                })
              }
            })
          }
        })
      },
      async doSubmit(){
        const added = this.checked.filter(id => !this.originalChecked.includes(id))
        const removed = this.originalChecked.filter(id => !this.checked.includes(id))
        let params = {
          company_id:this.companyId,
          added: added,
          removed: removed
        }
        this.$Modal.confirm({
          content: (this.checked.length<=0) ? '确定要全部下线吗' : '<p>确定提交吗</p>',
          onOk: async () => {
            let res = await this.$commonFun.postProxy('admin/company/editCompanyStationManage',params)
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip('操作成功',()=>{this.getInfo()})
            })
          },
        });
      },
      async doSearch(){
        this.searchData.company_id = this.companyId
        let res = await this.$commonFun.postProxy('admin/company/getCompanyStationManageInfo',this.searchData)
        this.checked = res.data.checked || []
        this.allStationID = res.data.all_station_ids || []
        this.stations = res.data.stations || []

        const gasNameKeyword = this.searchData.gas_name.toLowerCase()
        const stationIdKeyword = this.searchData.station_id.toLowerCase()
        const selectedProvince = this.searchData.province_name.toLowerCase()
        const selectedCity = this.searchData.city_name.toLowerCase()
        const selectedCounty = this.searchData.county_name.toLowerCase()
        const hasSearchCondition = gasNameKeyword || stationIdKeyword || selectedProvince || selectedCity || selectedCounty

        if (hasSearchCondition) {
          const gasNameMatches = []
          const stationIdMatches = []
          const locationMatches = []
          const noMatch = []
          res.data.stations.forEach(item => {
            const gasName = (item.gas_name || '').toLowerCase()
            const stationId = item.station_id.toString().toLowerCase()
            const province = item.province_name ? item.province_name.toLowerCase() : ''
            const city = item.city_name ? item.city_name.toLowerCase() : ''
            const county = item.county_name ? item.county_name.toLowerCase() : ''
            const isGasNameMatch = gasName.includes(gasNameKeyword) && gasNameKeyword
            const isStationIdMatch = stationId.includes(stationIdKeyword) && stationIdKeyword
            const isProvinceMatch = province.includes(selectedProvince) && selectedProvince
            const isCityMatch = city.includes(selectedCity) && selectedCity
            const isCountyMatch = county.includes(selectedCounty) && selectedCounty
            if (isGasNameMatch) {
              gasNameMatches.push(item)
            } else if (isStationIdMatch) {
              stationIdMatches.push(item)
            } else if (isProvinceMatch || isCityMatch || isCountyMatch) {
              locationMatches.push(item)
            } else {
              noMatch.push(item)
            }
          })
          this.stations = [...gasNameMatches, ...stationIdMatches, ...locationMatches, ...noMatch]
        } else {
          const selectedItems = []
          const unselectedItems = []
          res.data.stations.forEach(item => {
            if (this.checked.includes(item.station_id)) {
              selectedItems.push(item)
            } else {
              unselectedItems.push(item)
            }
          })
          this.stations = [...selectedItems, ...unselectedItems]
        }
      },
      editCompanyStationInfoChange (data) {
        if (data.length === this.stations.length) {
          this.indeterminate = false;
          this.checkAll = true;
        } else if (data.length > 0) {
          this.indeterminate = true;
          this.checkAll = false;
        } else {
          this.indeterminate = false;
          this.checkAll = false;
        }
      },
      checkAllCompanyStation(){
        this.checkAll = this.checked.length !== this.stations.length
        this.indeterminate = false;
        if (this.checkAll) {
          this.checked = this.allStationID;
        } else {
          this.checked = [];
        }
      },
    },
    mounted() {
      this.getInfo()
    },
  }
</script>

<style scoped lang="less">
  .wrapper {
    height: 700px;
    overflow-y: auto;
  }
  .custom-checkbox .scroller {
    display: block;
  }
  .row {
    height: 36px;
    line-height: 36px;
    padding: 0 12px;
    border-bottom: 1px solid #f5f5f5;
  }
</style>
